import { MinusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/daisy';
import CoursePath from '@/models/CoursePath';
import PedContentCard from '../ped-content/PedContentCard';

type EvaluationBlockSlavesListProps = {
  courseLineId: number;
  appliedCoursePaths: CoursePath[];
  onRemove: (index: number) => void;
};

export default function EvaluationBlockSlavesList({
  courseLineId,
  appliedCoursePaths,
  onRemove,
}: EvaluationBlockSlavesListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.evaluationsTab',
  });

  return (
    <div className="flex flex-col gap-3">
      {appliedCoursePaths.map((field, index) => {
        return (
          <PedContentCard
            key={field.id}
            coursePath={field}
            courseLineId={courseLineId}
            className="bg-base-300"
            moduleId={0}
            actions={
              <Button
                type="button"
                size="sm"
                variant="soft"
                color="error"
                onClick={() => onRemove(index)}
              >
                <MinusIcon className="w-4 h-4" />
                {t('removeCoursePath')}
              </Button>
            }
          />
        );
      })}
    </div>
  );
}
